module.exports = __webpack_public_path__ + "static/media/Ganjedibles-logo.fb4dfeb0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Ganjedibles-logo.png
 ** module id = 764
 ** module chunks = 0
 **/